import { createContext } from 'react';

type LargeSizeContextType = {
  isLargeMode: boolean;
};

const LargeSizeContext = createContext<LargeSizeContextType>({
  isLargeMode: false,
});

export default LargeSizeContext;
